import { BaseConnectionService } from "./baseConnectionService";
import {TeamMember} from "../../types/teamMember";

class TeamMemberConnectionService extends BaseConnectionService<TeamMember> {
  constructor() {
    super("team-members");
  }
}

export const teamMemberConnectionService = new TeamMemberConnectionService();
